import { Box } from "@mui/material";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton = () => {
  return (
    <a href="https://wa.me/7066979997" target="_blank" rel="noopener noreferrer">
      <Box
        sx={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          zIndex: 1000,
          backgroundColor: "#25D366",
          padding: "15px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
          "&:hover": { backgroundColor: "#1EBEA5" },
        }}
      >
        <FaWhatsapp style={{ fontSize: "30px", color: "white" }} />
      </Box>
    </a>
  );
};

export default WhatsAppButton;
